import * as React from 'react';
import { NavigatorStore } from './stores';
import * as styles from './Navigator.css';
import { inject, observer } from 'mobx-react';
import '../../styles/Sharepoint_4.css';
import { Megamenu } from './megamenu/Megamenu';
import { Environment } from '../../services/Environment';
import NavigatorService from '../../services/NavigatorService';
import UserService from '../../services/UserService';
import { IUserRole } from '../../interfaces/IUserRole';
import { Smartmenu } from './smartmenu/Smartmenu';
import { Helper } from '../../Helper';
import { IAIcon } from '../icon/Icon';
import { Phonebook } from './phonebook/Phonebook';
import { INavigatorResponse } from '../../interfaces/INavigatorResponse';
import ContentCreatorPanel from './contentCreatorPanel/ContentCreatorPanel';
import EventPanel from './eventPanel/EventPanel';
import { TenantSettingsService } from 'intraactive-sdk-helper';
import { ITenantSettings } from '../../interfaces/ITenantSettings';
import { PeopleFinderPanel } from './peopleFinderPanel/PeopleFinderPanel';
import MessagePanel from './messagePanel/MessagePanel';
const defaultNavigator = require('./configuration.json');
const IA_LOGO = require('../../images/intraactive-logo.png');
import { IAConfetti } from './confetti/Confetti';
import DateTimeService from '../../services/DateTimeService';
import { LoggingService } from '../../services/LoggingService';
import { sdkContainerInstance } from '../global';
import { LocalizationService } from '../../services/LocalizationService';
import { IAConditionalTooltipWrapper } from '../tooltip/ConditionalTooltipWrapper';
import AiAssistantPanel from './aiAssistantPanel/AiAssistantPanel';
import TranslationPanel from './translationPanel/TranslationPanel';
import TargetPreviewPopup from './admin/targetPreviewPopup/TargetPreviewPopup';
import TargetPreviewPanel from './targetPreviewPanel/TargetPreviewPanel';
export interface INavigatorProps {
  navigatorStore?: NavigatorStore;
  version: string;
}

export interface INavigatorState {
  version: string;
}

@inject('navigatorStore')
@observer
export class Navigator extends React.Component<INavigatorProps, INavigatorState> {

  private localizationService: LocalizationService = new LocalizationService();
  private resizeObserver: ResizeObserver | undefined;
  private readonly resizeHandler = () => this.resize();
  private readonly tenantSettingsService: TenantSettingsService<ITenantSettings> = new TenantSettingsService<ITenantSettings>(
    Environment.getEnvironmentForSettingsAPI(this.props.navigatorStore?.environment ?? "Production"),
    sdkContainerInstance
  );

  constructor(props: INavigatorProps) {
    super(props);
    this.state = {
      version: Helper.getRandomStringKey(),
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    if (localStorage.getItem('targetedPreviewIds') && this.props.navigatorStore) {
      this.props.navigatorStore.targetedPreviewIds = JSON.parse(localStorage.getItem('targetedPreviewIds') ?? "[]");
    }
    if (!this.props.navigatorStore?.isInEditMode) {
      this.props.navigatorStore?.getNavigatorFromCache();
      this.getNavigator();
    }
    if (location.search.indexOf('inteams') !== -1 && this.props.navigatorStore) {
      this.props.navigatorStore.inTeams = true;
    }
    this.getTenantSettings();
    this.getCurrentUser();
    this.props.navigatorStore?.getTargeting();
    if (this.props.navigatorStore) {
      this.props.navigatorStore.isMobile = window.innerWidth < 667 && !this.props.navigatorStore.isInEditMode;
      this.props.navigatorStore.isIpadInPortrait = window.innerWidth >= 667 && window.innerWidth < 1024 && !this.props.navigatorStore.isInEditMode;
      if (this.props.navigatorStore.isMobile && this.props.navigatorStore.navigator?.design?.menuBar) {
        this.props.navigatorStore.navigator.design.menuBar.layout = 'burger';
      }
    }
  }

  private getCurrentUser(): void {
    UserService.getCurrentUser(
      Environment.getEnvironmentForMainAPI(this.props.navigatorStore?.environment ?? "Production"),
      this.props.navigatorStore?.tenant ?? "",
      this.props.navigatorStore?.token ?? "").then(user => {
        if (this.props.navigatorStore) {
          this.props.navigatorStore.user = user;
        }
      });
  }

  private getTenantSettings(): void {
    if (this.props.navigatorStore?.tenant && this.props.navigatorStore?.token) {
      const tenantSettings = localStorage.getItem("IA_tenantSettings");
      if (tenantSettings && new DateTimeService().getDatePlusTwoMinuts(new Date(JSON.parse(tenantSettings).date)) > new Date()) {
        console.log("Using cached tenant settings");
        this.props.navigatorStore.tenantSettings = JSON.parse(tenantSettings).value;
      } else {
        console.log("Fetching tenant settings again");
        this.tenantSettingsService.getSettings(this.props.navigatorStore?.tenant?.substring(0, this.props.navigatorStore?.tenant?.indexOf('.') ?? 0) ?? "", undefined, this.props.navigatorStore?.token ?? "").then(setting => {
          if (this.props.navigatorStore) {
            this.props.navigatorStore.tenantSettings = setting;
            Helper.setLocalStorage("IA_tenantSettings", JSON.stringify({
              date: new Date(),
              value: setting
            }));
          }
        });
      }
    }
  }

  private escFunction(event: any): void {
    if (event.keyCode === 27) {
      if (this.props.navigatorStore) {
        this.props.navigatorStore.selectedPhonebook = undefined;
        this.props.navigatorStore.selectedPeopleFinder = undefined;
        this.props.navigatorStore.selectedEvent = undefined;
      }
    }
  }

  public componentWillReceiveProps(props: INavigatorProps): void {
    if (props.version !== this.props.version && !this.props.navigatorStore?.isInEditMode) {
      this.getNavigator();
    }
  }

  public componentDidMount(): void {
    const el = this.props.navigatorStore?.id ? document.getElementById(this.props.navigatorStore.id) : null;
    // In edit mode that element's width is driven by navigatorStore.width itself (not
    // the viewport), so observing it would never react to an actual screen resize.
    if (el && !this.props.navigatorStore?.isInEditMode) {
      this.resizeObserver = new ResizeObserver(this.resizeHandler);
      this.resizeObserver.observe(el);
    } else {
      window.addEventListener('resize', this.resizeHandler);
    }
    window?.addEventListener('orientationchange', () => location.reload());
    document.addEventListener('keydown', (event) => this.escFunction(event), false);
    if (this.props.navigatorStore?.asMobileAppComponent) {
      this.props.navigatorStore.isShowingMegamenu = true;
    }
    this.addLogOutOnCLickListener();
    // fix bug where sharepoint header was shown above the navigator. Force the z-index to be auto
    let sharepointHeaders = document.querySelectorAll<HTMLDivElement>("[class*=headerRow]");
    sharepointHeaders.forEach((element) => {
      element.style.zIndex = "auto";
    });
  }

  private onClick(trackingType: string) {
    if (!this.props.navigatorStore?.isInEditMode) {
      if (!this.props.navigatorStore?.isMobile) {
        LoggingService.trackEvent("Navigator", {
          ActionType: "LinkClick",
          Type: trackingType,
          Title: "Logo",
          Url: this.props.navigatorStore?.navigator?.design?.menuBar?.logoLinkUrl,
          Tenant: this.props.navigatorStore?.tenant,
          Instance: this.props.navigatorStore?.instance,
          UserId: this.props.navigatorStore?.token,
          Version: this.props.navigatorStore?.navigator?.version?.id,
          PageUrl: window.location.pathname.toLowerCase(),
          SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
        });
      }
    }
  }

  private addLogOutOnCLickListener(): void {
    const SharepointSignOutButton = document.getElementById("mectrl_body_signOut");
    if (SharepointSignOutButton) {
      SharepointSignOutButton.onmousedown = () => {
        console.log("Logout");
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        sessionStorage.clear();
        localStorage.clear();
        NavigatorService.signOut(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore?.environment ?? "Production")}/api/authentication/cookies`, this.props.navigatorStore.token);
      }
    } else {
      setTimeout(() => {
        this.addLogOutOnCLickListener();
      }, 1000);
    }
  }

  public componentWillUnmount(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.resizeHandler);
    }
    document.removeEventListener('keydown', (event) => this.escFunction(event), false);
    window.removeEventListener('orientationchange', () => location.reload());
    if (document.getElementById('IA_Navigator') != undefined) {
      document.getElementById('IA_Navigator').outerHTML = '';
    }
  }

  public resize(): void {
    this.props.navigatorStore?.resize();
    this.forceUpdate();
  }

  private getNavigator(): void {
    if (this.props.navigatorStore) {
      this.props.navigatorStore.isLoading = true;
    }
    NavigatorService.getNavigator(
      Environment.getEnvironmentForMainAPI(this.props.navigatorStore?.environment ?? "Production"),
      `/api/${this.props.navigatorStore?.tenant}/navigator?instanceName=${this.props.navigatorStore?.instance ? this.props.navigatorStore.instance : "Default"}&targeting=${!(this.props.navigatorStore?.isInEditMode || this.props.navigatorStore?.targetedPreviewIds?.length > 0)}`,
      this.props.navigatorStore?.token,
      this.props.navigatorStore?.instance ?? "Default"
    ).then((navigatorResponse: INavigatorResponse) => {
      if (navigatorResponse.navigator != undefined && (navigatorResponse.navigator.design != null || this.props.navigatorStore?.isInEditMode)) {
        //if (this.props.navigatorStore.navigator.version.id === navigatorResponse.navigator.version.id) {
        if (navigatorResponse.navigator.design != null) {
          if (navigatorResponse.navigator.smartmenu == null) {
            navigatorResponse.navigator.smartmenu = {
              elements: [],
            };
          }
          if (this.props.navigatorStore?.isMobile) {
            // Check mobile isIpadInPortrait
            navigatorResponse.navigator.design.menuBar.layout = 'burger';
          }
          if (JSON.stringify(this.props.navigatorStore?.navigator) != JSON.stringify(navigatorResponse.navigator)) {
            this.props.navigatorStore?.setNavigator(navigatorResponse.navigator);
            this.setState({ version: Helper.getRandomStringKey() });
          }
          this.props.navigatorStore?.resize();
          this.resize();
        } else {
          this.props.navigatorStore?.setNavigator(defaultNavigator);
          NavigatorService.createNavigator(
            `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore?.environment ?? "Production")}/api/${this.props.navigatorStore?.tenant}/navigator?instanceName=${this.props.navigatorStore?.instance ?? "Default"}`,
            this.props.navigatorStore?.instanceId ?? 0,
            this.props.navigatorStore?.token ?? "",
            this.props.navigatorStore?.instance ?? "Default"
          ).then(() => {
            this.props.navigatorStore?.resize();
            this.resize();
          });
        }
        if (localStorage.getItem('userRole') == undefined) {
          UserService.getUserRole(
            Environment.getEnvironmentForMainAPI(this.props.navigatorStore?.environment ?? "Production"),
            this.props.navigatorStore?.tenant ?? "",
            this.props.navigatorStore?.instanceId ?? 0,
            this.props.navigatorStore?.token ?? "",
            'IntraActive-NavigatorAdmin'
          ).then((userRole: IUserRole) => {
            this.props.navigatorStore?.setUserRole(userRole);
            Helper.setLocalStorage('userRole', JSON.stringify(userRole));
          });
          if (this.props.navigatorStore) {
            this.props.navigatorStore.isLoading = false;
          }
        } else {
          this.props.navigatorStore?.setUserRole(JSON.parse(localStorage.getItem('userRole') ?? '{}'));
          if (this.props.navigatorStore?.isLoading) {
            this.props.navigatorStore.isLoading = false;
          }
        }
        //}
      }
    });
  }

  render() {
    let rgbColor;
    if (this.props.navigatorStore?.navigator != undefined) {
      rgbColor =
        this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.navigator.design != undefined && this.props.navigatorStore.navigator.design.menuBar != undefined
          ? Helper.convertHexToRgb(this.props.navigatorStore.navigator?.design?.menuBar?.iconColor)
          : undefined;
    }
    let position: any = 'relative';
    if ((this.props.navigatorStore?.navigator != undefined && this.props.navigatorStore.navigator?.design?.menuBar?.layout == 'vertical') || this.props.navigatorStore?.isInEditMode) {
      position = 'absolute';
    }
    if (this.props.navigatorStore?.inTeams) {
      position = 'fixed';
    }
    let heatMapColor = this.props.navigatorStore?.isShowingAnalytics && this.props.navigatorStore?.doneSettingClicks ? this.props.navigatorStore.getHeatMapColorHSL(this.props.navigatorStore.clickFilter === 'Total' ? this.props.navigatorStore.navigator?.design?.menuBar?.logoClicks : this.props.navigatorStore.navigator?.design?.menuBar?.logoUniqueClicks) : "";
    return (
      <div
        style={
          this.props.navigatorStore?.inTeams
            ? {
              position: 'relative',
              height: 40,
            }
            : this.props.navigatorStore?.isMobile ? { height: "100%" } : {}
        }
      >
        <div
          id={this.props.navigatorStore?.id}
          className={styles.navigator}
          style={{
            position: position,
            zIndex: this.props.navigatorStore?.isInEditMode ? this.props.navigatorStore?.isShowingAnalytics ? 601 : 1 : 8,
            height: "100%",
            width: this.props.navigatorStore?.isInEditMode ? this.props.navigatorStore?.width : "100%"
          }}
        >
          {this.props.navigatorStore?.isInEditMode && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: '#ffffff',
                boxShadow: '0px 0px 15px 2px rgba(0,0,0,0.12)',
                width: this.props.navigatorStore?.width,
                height:
                  this.props.navigatorStore?.navigator != undefined && this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical' && this.props.navigatorStore?.navigatorHeight != undefined
                    ? this.props.navigatorStore?.navigatorHeight
                    : this.props.navigatorStore?.contentHeight != undefined
                      ? this.props.navigatorStore?.contentHeight + 40
                      : 200,
              }}
            />
          )}
          {this.props.navigatorStore?.isShowingAnalytics && (
            <div className={styles.analyticsFooter}
              style={{
                width: this.props.navigatorStore?.width,
              }}
            >
              <ul>
                <li>{this.props.navigatorStore?.totalClicks} {this.localizationService.strings.Navigator_Analytics_TotalClicks}</li>
                <li>{this.localizationService.strings.Navigator_Analytics_FooterLeastPopular} <img src='https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/Heatmap2.png' alt="Color scale from least to most popular" style={{ verticalAlign: "text-top" }} /> {this.localizationService.strings.Navigator_Analytics_FooterMostPopular}</li>
                <li>{this.props.navigatorStore?.totalUniqueClicks} {this.localizationService.strings.Navigator_Analytics_UniqueClicks}</li>
              </ul>
            </div>
          )}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && (
            <nav
              aria-label={this.props.navigatorStore?.instance || "Main navigation"}
              className={
                this.props.navigatorStore?.navigator != undefined && this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical' ? styles.navigatorBarVertical : styles.navigatorBar
              }
              id="IA_navigator_bar"
              style={{
                background: this.props.navigatorStore?.navigator != undefined && this.props.navigatorStore?.navigator?.design?.menuBar?.backgroundColor ? this.props.navigatorStore?.navigator?.design?.menuBar?.backgroundColor : "#ffffff",
                marginTop: this.props.navigatorStore?.navigatorTop,
                height: this.props.navigatorStore?.moreHorizontalTopItemsToDisplay ? (this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? 80 : 120) : (this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? 40 : 80),
                transition: this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical' && !this.props.navigatorStore?.isInEditMode ? 'all 200ms' : 'none',
                zIndex: this.props.navigatorStore?.asMobileAppComponent || this.props.navigatorStore?.isShowingAnalytics ? undefined : 900002,
                padding: `0px ${this.props.navigatorStore?.navigationBarOffset < 28 ? 0 : this.props.navigatorStore?.navigationBarOffset}px`,
                width: this.props.navigatorStore?.isInEditMode ? this.props.navigatorStore?.width : "100%"
              }}
            >
              {this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.navigator?.design?.menuBar?.layout === 'burger' && !(this.props.navigatorStore.isShowingAdditionalSmartmenuItems && this.props.navigatorStore.isMobile) && (
                <button
                  className={styles.menuButton}
                  type="button"
                  aria-label={this.props.navigatorStore.isShowingMegamenu ? "Close navigation menu" : "Open navigation menu"}
                  aria-expanded={!!this.props.navigatorStore.isShowingMegamenu}
                  aria-controls="IA_megamenu"
                  style={{
                    backgroundColor: "transparent",
                    left: this.props.navigatorStore.isMobile ? 12 : 28
                  }}
                  onClick={() => {
                    this.props.navigatorStore?.toggleMegamenu();
                  }}
                >
                  <IAIcon
                    title="BurgerMenu"
                    size={18}
                    color={this.props.navigatorStore.navigator?.design?.menuBar?.iconColor}
                    style={{
                      marginTop: 3,
                    }}
                  />
                </button>
              )}
              {this.props.navigatorStore.navigator != undefined &&
                this.props.navigatorStore.navigator?.design?.menuBar?.logo != undefined &&
                this.props.navigatorStore.navigator?.design?.menuBar?.logo != '' &&
                this.props.navigatorStore.navigator?.design?.menuBar?.layout != 'vertical' &&
                !(this.props.navigatorStore.isShowingAdditionalSmartmenuItems && this.props.navigatorStore.isMobile) && (
                  <a
                    data-interception={"on"}
                    target={"_self"}
                    onClick={() =>
                      this.onClick("Link")}
                    href={
                      this.props.navigatorStore.isShowingAnalytics
                        ? undefined
                        : this.props.navigatorStore.navigator?.design?.menuBar?.logoLinkUrl}
                  >
                    <IAConditionalTooltipWrapper
                      condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks}
                      tooltipContent={
                        <div>
                          {this.props.navigatorStore?.getClickTooltipLocalizationString(this.props.navigatorStore?.clickFilter === 'Total' ? this.props.navigatorStore?.navigator?.design?.menuBar?.logoClicks : this.props.navigatorStore?.navigator?.design?.menuBar?.logoUniqueClicks)}
                          ({this.props.navigatorStore?.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore?.clickFilter === 'Total' ? this.props.navigatorStore?.navigator?.design?.menuBar?.logoClicks : this.props.navigatorStore?.navigator?.design?.menuBar?.logoUniqueClicks)}%)
                        </div>
                      }
                      wrapper={(content) =>
                        <div>
                          {content}
                          <div className={styles.logoAnalyticsOverlay}
                            style={{
                              left: this.props.navigatorStore?.navigator?.design?.menuBar?.layout === 'horizontal' ? 16 : 6,
                              width: this.props.navigatorStore?.logoWidth,
                              height: this.props.navigatorStore?.logoHeight,
                              backgroundImage: `radial-gradient(circle, ${heatMapColor} 30%, transparent 100%)`,
                            }}
                          />
                        </div>
                      }
                    >
                      <img
                        src={
                          this.props.navigatorStore?.navigator?.design?.menuBar?.logo != undefined
                            ? this.props.navigatorStore?.navigator?.design?.menuBar?.logo
                            : IA_LOGO
                        }
                        alt={this.props.navigatorStore?.instance || "Home"}
                        id="IA_navigator_logo"
                        className={styles.logo}
                        style={{
                          width: "auto",
                          marginLeft: this.props.navigatorStore?.isMobile ? 18 : this.props.navigatorStore?.navigationBarOffset <= 28 ? 28 : 10,
                          top: this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "modern" ? 25 : 5
                        }}
                        onLoad={() => this.props.navigatorStore?.resize()}
                      />
                    </IAConditionalTooltipWrapper>
                  </a>
                )}
              {this.props.navigatorStore?.navigator != undefined && this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical' && (
                <button
                  className={styles.verticalMenuExpandButton}
                  type="button"
                  aria-expanded={!!this.props.navigatorStore?.verticalMenuExpanded}
                  aria-label={this.props.navigatorStore?.verticalMenuExpanded ? "Collapse navigation" : "Expand navigation"}
                  style={{
                    width: this.props.navigatorStore?.verticalMenuExpanded ? '300px' : '50px',
                    backgroundColor: this.props.navigatorStore?.navigator?.design?.menuBar?.backgroundColor,
                    borderTop: `1px solid rgba(${rgbColor?.r},${rgbColor?.g},${rgbColor?.b},0.3)`,
                  }}
                  onClick={() => {
                    this.props.navigatorStore!.verticalMenuExpanded = !this.props.navigatorStore!.verticalMenuExpanded;
                    this.forceUpdate();
                  }}
                >
                  <IAIcon
                    title="Double arrow right"
                    size={25}
                    color={this.props.navigatorStore.navigator?.design?.menuBar?.iconColor}
                    style={{
                      marginTop: 1,
                      float: 'right',
                      marginRight: 12,
                      transform: `rotate(${this.props.navigatorStore.verticalMenuExpanded ? 180 : 0}deg)`,
                      transition: 'all 200ms ease-in-out',
                    }}
                  />
                </button>
              )}
            </nav>
          )}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <Phonebook isShowing={this.props.navigatorStore?.selectedPhonebook != undefined} />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && this.props.navigatorStore?.tenantSettings?.peopleFinder?.enabled && <PeopleFinderPanel />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <EventPanel />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent &&
            <TargetPreviewPanel
              fontSlots={this.props.navigatorStore.fontSlots}
              onClose={(targetedPreviewId: number[]) => {
                if (targetedPreviewId?.length > 0) {
                  Helper.setLocalStorage("targetedPreviewIds", JSON.stringify(targetedPreviewId));
                } else {
                  localStorage.removeItem("targetedPreviewIds");
                }
                location.reload();
              }}
            />
          }
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <MessagePanel />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <ContentCreatorPanel />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <AiAssistantPanel />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.droppableSmartmentTopItemSpotsAreShowing &&
            <Megamenu
              version={this.state.version}
              toogleMegamenu={this.props.navigatorStore?.isShowingMegamenu}
            />
          }
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <Smartmenu />}
          {this.props.navigatorStore?.navigator != undefined && !this.props.navigatorStore?.asMobileAppComponent && <TranslationPanel />}
          {this.props.navigatorStore?.checkedOut && !this.props.navigatorStore?.isShowingAnalytics && <div className={styles.checkedOutOverlay} />}
        </div>
        <IAConfetti />
        {this.props.navigatorStore?.showTargetPreviewPopup &&
          <TargetPreviewPopup
            onClose={() => {
              this.props.navigatorStore!.showTargetPreviewPopup = false;
            }}
          />
        }
      </div>
    );
  }
}
